const experimentName = "trial_included_for_meta_campaign_traffic_202608";
const experimentVersion = "v1";
const groupKey = `experiment:${experimentName}:${experimentVersion}:group`;
const checkboxKey = `experiment:${experimentName}:${experimentVersion}:trial-checkbox`;
const startedKey = `experiment:${experimentName}:${experimentVersion}:started`;
const VARIANT_PARAM = "pp_auto_14d";
const ELIGIBLE_PAGE_TYPES = ["product", "collection", "index", "list-collections"];

// Helper function to inject 'Add Trial' button in cart drawer
function injectTrialButton() {
  const group = localStorage.getItem(groupKey);
  if (group === "variant") {
    const template = document.querySelectorAll('.trial-opt-in-template');
    for (const t of template) {
      const clone = t.content.cloneNode(true);
      t.replaceWith(clone);
    }

    const templateMobile = document.querySelectorAll('.trial-opt-in-template-mobile');
    for (const t of templateMobile) {
      const clone = t.content.cloneNode(true);
      t.replaceWith(clone);
    }
  }
}